import { FeatureStorage } from "@/_services/storage";

export default {
  computed: {
    tabs() {
      if (this.baseView.mode == "create" && !this.baseView.id) {
        return [
          {
            text: "Details",
            path: `/customer/create`,
            applicationFeatureCode: "Customer",
          },
        ];
      } else {
        let validTabs = [
          {
            text: "Details",
            path: `/customer/review/${
              this.baseView.tempId ? this.baseView.tempId : this.baseView.id
            }`,
            applicationFeatureCode: "Customer",
          },
          {
            text: "Delivery Addresses",
            path: `/customer-delivery-address/${
              this.baseView.tempId ? this.baseView.tempId : this.baseView.id
            }`,
            applicationFeatureCode: "Customer",
          },
          {
            text: "Contacts",
            path: `/customer-contact/${
              this.baseView.tempId ? this.baseView.tempId : this.baseView.id
            }`,
            applicationFeatureCode: "Customer",
          },
          {
            text: "Notes",
            path: `/customer-note/${
              this.baseView.tempId ? this.baseView.tempId : this.baseView.id
            }`,
            applicationFeatureCode: "Customer",
          },
          {
            text: "Agent",
            visible: FeatureStorage.checkPermission(
              "AgentCommission",
              this.baseView.mode
            ),
            path: `/customer-agent/${
              this.baseView.tempId ? this.baseView.tempId : this.baseView.id
            }`,
            applicationFeatureCode: "AgentCommission",
          },
          {
            text: "Freight",
            visible: FeatureStorage.checkPermission(
              "CustomerSalesContract",
              this.baseView.mode
            ),
            path: `/customer-freight-charge/${
              this.baseView.tempId ? this.baseView.tempId : this.baseView.id
            }`,
            applicationFeatureCode: "FreightCharge",
          },
          {
            text: "Transactions",
            path: `/customer-transaction-history/${
              this.baseView.tempId ? this.baseView.tempId : this.baseView.id
            }`,
            applicationFeatureCode: "CustomerTransactionHistory",
          },
          {
            text: "Product History",
            path: `/customer-product-history/${
              this.baseView.tempId ? this.baseView.tempId : this.baseView.id
            }`,
            applicationFeatureCode: "CustomerProductHistory",
          },
          {
            text: "Attributes",
            path: `/customer-attributes/${
              this.baseView.tempId ? this.baseView.tempId : this.baseView.id
            }`,
            applicationFeatureCode: "CustomerAttributes",
          },
          {
            text: "Call Logs",
            path: `/customer-call-logs/${
              this.baseView.tempId ? this.baseView.tempId : this.baseView.id
            }`,
            applicationFeatureCode: "CallLogs",
          },
          {
            text: "Surveys",
            path: `/customer-surveys/${
              this.baseView.tempId ? this.baseView.tempId : this.baseView.id
            }`,
            applicationFeatureCode: "SurveyResponse",
          },
          {
            text: "Sample Requests",
            path: `/customer-sample-requests/${
              this.baseView.tempId ? this.baseView.tempId : this.baseView.id
            }`,
            applicationFeatureCode: "SampleRequests",
          },
          {
            text: "Price Groups",
            visible: FeatureStorage.checkPermission(
              "PriceGroup",
              this.baseView.mode
            ),
            path: `/customer-price-group/${
              this.baseView.tempId ? this.baseView.tempId : this.baseView.id
            }`,
            applicationFeatureCode: "PriceGroup",
          },
        ];
        // if (FeatureStorage.checkPermission("FreightCharge", "review")) {
        //   validTabs.push({
        //     text: "Freight",
        //     path: `/customer-freight-charge/${this.baseView.id}`,
        //     applicationFeatureCode: "FreightCharge",
        //   });
        // }

        return validTabs;
      }
    },
  },
};
